(function () {
  var cfg = window.__ucPwa || {};
  var deferredPrompt = null;
  var installed = false;

  function isIos() {
    return /iphone|ipad|ipod/i.test(navigator.userAgent) ||
      (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
  }

  function isStandalone() {
    return (
      window.matchMedia('(display-mode: standalone)').matches ||
      window.navigator.standalone === true
    );
  }

  function injectManifest() {
    if (document.querySelector('link[rel="manifest"][data-uc-pwa]')) return;
    var iconSrc = cfg.icon192 || cfg.icon180 || cfg.icon;
    var icons = [];
    if (cfg.icon192) {
      icons.push({ src: cfg.icon192, sizes: '192x192', type: 'image/png', purpose: 'any' });
    }
    if (cfg.icon512) {
      icons.push({ src: cfg.icon512, sizes: '512x512', type: 'image/png', purpose: 'any' });
      icons.push({ src: cfg.icon512, sizes: '512x512', type: 'image/png', purpose: 'maskable' });
    } else if (iconSrc) {
      icons.push({ src: iconSrc, sizes: '512x512', type: 'image/png', purpose: 'any' });
    }
    var manifest = {
      name: cfg.name || 'Urban Chic',
      short_name: cfg.shortName || 'Urban Chic',
      description: cfg.description || 'Urban Chic Boutique',
      start_url: cfg.startUrl || '/',
      scope: cfg.scope || '/',
      display: 'standalone',
      orientation: 'portrait-primary',
      background_color: cfg.backgroundColor || '#ffffff',
      theme_color: cfg.themeColor || '#fbe4e7',
      icons: icons
    };
    var blob = new Blob([JSON.stringify(manifest)], { type: 'application/json' });
    var link = document.createElement('link');
    link.rel = 'manifest';
    link.setAttribute('data-uc-pwa', '1');
    link.href = URL.createObjectURL(blob);
    document.head.appendChild(link);
  }

  function registerSw() {
    if (!('serviceWorker' in navigator)) return Promise.resolve(false);
    var swUrl = cfg.swUrl;
    if (!swUrl) return Promise.resolve(false);
    return navigator.serviceWorker.register(swUrl).then(function () {
      return true;
    }).catch(function () {
      return false;
    });
  }

  function setStatus(el, text, kind) {
    if (!el) return;
    el.hidden = !text;
    el.textContent = text || '';
    el.dataset.kind = kind || '';
  }

  function updateUi() {
    var root = document.querySelector('[data-uc-add-home]');
    if (!root) return;

    var btn = root.querySelector('[data-uc-install]');
    var status = root.querySelector('[data-uc-status]');
    var iosHelp = root.querySelector('[data-uc-ios-help]');
    var androidHelp = root.querySelector('[data-uc-android-help]');

    if (isStandalone() || installed) {
      if (btn) {
        btn.disabled = true;
        btn.textContent = 'Already on your home screen';
      }
      setStatus(status, 'Urban Chic is ready on your device.', 'ok');
      if (iosHelp) iosHelp.hidden = true;
      if (androidHelp) androidHelp.hidden = true;
      return;
    }

    if (isIos()) {
      if (btn) btn.hidden = true;
      if (iosHelp) iosHelp.hidden = false;
      if (androidHelp) androidHelp.hidden = true;
      setStatus(status, 'On iPhone, use Share → Add to Home Screen. Name: Urban Chic.', 'info');
      return;
    }

    if (iosHelp) iosHelp.hidden = true;

    if (deferredPrompt && btn) {
      btn.hidden = false;
      btn.disabled = false;
      btn.textContent = 'Add Urban Chic';
      if (androidHelp) androidHelp.hidden = true;
      setStatus(status, 'Tap below — confirm Urban Chic on the next screen.', 'ok');
    } else if (btn) {
      btn.hidden = false;
      btn.disabled = false;
      btn.textContent = 'Add Urban Chic';
      if (androidHelp) androidHelp.hidden = false;
      setStatus(
        status,
        'If the install popup does not appear, use your browser menu → Add to Home screen / Install app.',
        'info'
      );
    }
  }

  async function install() {
    var root = document.querySelector('[data-uc-add-home]');
    var status = root && root.querySelector('[data-uc-status]');
    var btn = root && root.querySelector('[data-uc-install]');

    if (isIos()) {
      updateUi();
      return;
    }

    if (!deferredPrompt) {
      updateUi();
      return;
    }

    if (btn) btn.disabled = true;
    deferredPrompt.prompt();
    try {
      var choice = await deferredPrompt.userChoice;
      if (choice && choice.outcome === 'accepted') {
        installed = true;
        setStatus(status, 'Done — Urban Chic was added.', 'ok');
      } else {
        setStatus(status, 'Install cancelled. You can try again anytime.', 'info');
        if (btn) btn.disabled = false;
      }
    } catch (e) {
      setStatus(status, 'Could not open the install prompt. Try your browser menu.', 'info');
      if (btn) btn.disabled = false;
    }
    deferredPrompt = null;
    updateUi();
  }

  window.addEventListener('beforeinstallprompt', function (event) {
    event.preventDefault();
    deferredPrompt = event;
    updateUi();
  });

  window.addEventListener('appinstalled', function () {
    installed = true;
    deferredPrompt = null;
    updateUi();
  });

  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-uc-install]');
    if (!btn) return;
    event.preventDefault();
    install();
  });

  injectManifest();
  registerSw().finally(function () {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', updateUi);
    } else {
      updateUi();
    }
  });
})();
